import React from "react";
import svg10 from "../../../../assets/svg/svg10.svg";
import { useNavigate } from "react-router-dom";

function JoinNetwork({ title, subtitle }) {
  const navigate = useNavigate();
  const handleRequestDemo = () => navigate("/request-demo");

  return (
    <div className="lg:py-[6rem] py-[3rem] flex items-center justify-center text-center flex-col lg:px-0 px-3 bg-bulk-network">
      <div className="text-[#111827] lg:text-[2.875rem] text-[1.2rem] font-[600] leading-[3.375rem] lg:max-w-[51.92313rem] w-full">
    {title}
      </div>

      <div className="mt-[1.5rem] text-[#4B5563] font-[400] text-[1.125rem] font-interSans leading-[1.75rem]">
      {subtitle}
      </div>

      <button onClick={handleRequestDemo} className="cstm-btn-2 lg:mt-[3.25rem] mt-[1rem] lg:!w-[16.75rem] !w-full">
        Request Demo <img src={svg10} alt="svg10" />
      </button>
    </div>
  );
}

export default JoinNetwork;
